var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasApiAccess()
        ? _c(
            "b-card",
            { staticClass: "mb-4", attrs: { "header-tag": "header" } },
            [
              _c("template", { slot: "header" }, [
                _c("h3", [_vm._v("API Key")])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "By generating a new API key your existing one will be revoked and overwritten."
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.generateKey()
                    }
                  }
                },
                [_vm._v("Generate Key")]
              ),
              _vm._v(" "),
              _vm.apiToken
                ? _c("div", { staticClass: "mt-3" }, [
                    _c("p", [
                      _vm._v(
                        "Here is your new API Key, please store it in a safe place. This won't be displayed after you leave this page."
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "api-key mt-3" }, [
                      _vm._v(_vm._s(_vm.apiToken))
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        { attrs: { "header-tag": "header" } },
        [
          _c("template", { slot: "header" }, [
            _c("h3", [_vm._v("Reset Password")])
          ]),
          _vm._v(" "),
          !_vm.passwordHasBeenReset
            ? _c("p", [
                _vm._v("You will be sent a link to reset your password.")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function($event) {
                  return _vm.generatePasswordReset()
                }
              }
            },
            [_vm._v("Reset Password")]
          ),
          _vm._v(" "),
          _vm.passwordHasBeenReset
            ? _c("div", { staticClass: "mt-3" }, [
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(
                    "A link to reset your password has been sent to your email address. If you do not receive an email within 5 minutes, please check your SPAM folder."
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47aa12d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47aa12d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = JjG3
// module chunks = 1